import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const RestoPage = () => (
  <Layout>
      <div class="container col-8">
    <SEO title="Pembuatan website restoran cafe rumah makan" />
    <h1><strong><a href="/resto" class="text-primary" title="jasa pembuatan website restoran cafe rumah makan">RESTO CAFE RUMAH MAKAN</a></strong></h1><hr/>
    <p>Saat ini pengusaha kuliner rumah makan restoran cafe wajib memiliki sebuah website sebagai symbol online usaha mereka di dunia net, manfaat lain adalah memberikan informasi mengenai apa menu makanan dan minuman hingga kebutuhan untuk layanan yang disediakan pada restoran cafe rumah makan mu.</p>
    <div class="embed-responsive embed-responsive-21by9 rounded">
    <iframe title="pembuatan website restoran rumah makan cafe" width="560" height="315" src="https://www.youtube.com/embed/guHJc2wEdJ4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
<p><a href="/resto" class="text-primary" title="jasa pembuatan website restoran cafe rumah makan">Pembuatan website restoran cafe rumah makan</a> dan usaha kuliner sangat bermanfaat dalam kemajuan bisnis untuk selalu update dengan kebutuhan informasi yang dibutuhkan oleh pelanggan resto cafe.</p>
<p>Dukungan desain foto ilustrasi dan image produk terbaik agar menu makanan dan minuman semakin membuat pengunjung website tergoda untuk langsung datang ke restoran cafe mu dan didukung video animasi dan cinema promosi video menjadi lebih baik dalam hal promosi menu makanan dan minuman serta layanan restoran cafe rumah makan mu.</p>
    <p>Segera buat website kamu sekarang untuk masa depan lebih baik dalam kemajuan bisnis mu.</p>
    <Link class="btn btn-lg btn-primary rounded-pill p-3 md-5" to="/price">Price list</Link>
    <Link class="btn btn-lg btn-primary rounded-pill p-3 md-5" to="/">Home Page</Link>
    <br/><br/>
    </div>
  </Layout>
)

export default RestoPage
